import { useState, useEffect } from 'react';
import { SSOProps } from '@types';
import { clearCookie } from '@utils/cookieHelper';
import { auth, config } from 'config';
import { useNavigate } from 'react-router-dom';
import { getAccountConnectToken } from '@services/AccountConnectFormService';

const useAccountDetailSSO = (url: string) => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [ssoData, setSsoData] = useState<SSOProps>({
        url: '',
        token: ''
    });
    const updateSsoData = ({ url, token }: { url: string; token: string }) => {
        setSsoData({
            url,
            token
        });
    };

    useEffect(() => {
        const fetchAccountDetailSSO = async () => {
            setLoading(true);
            try {
                const { response } = await getAccountConnectToken(`${config.env('ssoUrl')}`, `${config.env('xApiKey')}`);
                if (response) {
                    auth.getOkta().tokenManager.clear();
                    clearCookie();
                    updateSsoData({ url, token: response?.signinToken });
                } else navigate('error');
            } catch (err) {
                setError('Error fetching account details');
            } finally {
                setLoading(false);
            }
        };
        fetchAccountDetailSSO();
    }, [url]);
    return { ssoData, loading, error };
};

export default useAccountDetailSSO;
